// reducer is a function that accepts an empty state and an action type and it will return a new updated state

import {PRODUCT_LIST_SUCCESS, PRODUCT_LIST_FAIL} from '../constants/productConstants'

export const productListReducer = (state={product:[]},action) => {
    switch(action.type){
        case PRODUCT_LIST_SUCCESS:
            return{product:action.payload}
        case PRODUCT_LIST_FAIL:
            return{product:action.error}  
        default:
            return state      
    }
}